import './styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-image">
        <img src="/footer.png" alt="Footer" />
      </div>
    </footer>
  );
};

export default Footer;
